module.exports = __webpack_public_path__ + "static/media/warning.b9cdb529.svg";